import React from 'react';
import { Label } from '../Label';
export const OffreExclusiveLabel = () => (React.createElement(Label, { textColor: "red800", backgroundColor: "red200" }, "Offre Exclusive"));
